import { useCallback, useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";
import { AcquisitionFullnameOption } from "models/acquisition-import";

export const useAcquisitionFullnameOptions = (
  kind: "classifications" | "departments"
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<AcquisitionFullnameOption[]>([]);
  const { fetchWithReauth } = useAuth();
  const noun = kind === "classifications" ? "classifications" : "departments";

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/acquisition-imports/${kind}`,
        { method: "GET" }
      );
      const data = (await checkResponse(response)) as {
        items?: AcquisitionFullnameOption[];
      };
      setItems(data.items || []);
    } catch (err) {
      const message =
        err instanceof Error
          ? err.message
          : "Failed to load " + noun + " from NetSuite.";
      setError(message);
      setItems([]);
      console.error("Error loading " + noun + ":", err);
    } finally {
      setLoading(false);
    }
  }, [fetchWithReauth, kind, noun]);

  return { items, loading, error, load };
};
